import React from "react";
import { Link, useLocation } from "react-router-dom";
import { BRAND } from "@/constants/brand";
import { Menu, X } from "lucide-react";

export default function MarketingLayout({ children }) {
  const [open, setOpen] = React.useState(false);
  const loc = useLocation();
  const links = [
    { to: "/features", label: "Features" },
    { to: "/pricing", label: "Pricing" },
    { to: "/community", label: "Community" },
    { to: "/docs", label: "Docs" },
  ];

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-[#FFFFF0]">
      <header className="sticky top-0 z-50 bg-[#0A0A0A]/95 backdrop-blur-sm border-b border-[#1E1E1E]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 group" data-testid="brand-home-link">
            <div className="w-7 h-7 border border-[#D4AF37] flex items-center justify-center">
              <div className="w-2 h-2 bg-[#D4AF37]"></div>
            </div>
            <span className="font-editorial text-xl tracking-tight">{BRAND.short}<span className="text-[#D4AF37]"> AI</span></span>
          </Link>
          <nav className="hidden md:flex items-center gap-8 text-sm">
            {links.map((l) => (
              <Link key={l.to} to={l.to}
                className={`transition-colors ${loc.pathname === l.to ? "text-[#FFFFF0]" : "text-[#A1A1AA] hover:text-[#FFFFF0]"}`}
                data-testid={`nav-${l.label.toLowerCase()}`}>
                {l.label}
              </Link>
            ))}
          </nav>
          <div className="hidden md:flex items-center gap-3">
            <Link to="/login" className="text-sm text-[#A1A1AA] hover:text-[#FFFFF0] transition-colors" data-testid="nav-login">Log in</Link>
            <Link to="/signup" className="bg-[#D4AF37] text-[#0A0A0A] px-5 py-2 text-sm font-medium hover:bg-[#F59E0B] transition-colors" data-testid="nav-signup">
              Start creating
            </Link>
          </div>
          <button className="md:hidden text-[#FFFFF0]" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle">
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
        {open && (
          <div className="md:hidden bg-[#0A0A0A] border-t border-[#1E1E1E] px-6 py-4 space-y-3">
            {links.map((l) => (
              <Link key={l.to} to={l.to} className="block text-sm text-[#A1A1AA]" onClick={() => setOpen(false)}>
                {l.label}
              </Link>
            ))}
            <Link to="/login" className="block text-sm text-[#A1A1AA]" onClick={() => setOpen(false)}>Log in</Link>
            <Link to="/signup" className="block bg-[#D4AF37] text-[#0A0A0A] px-4 py-2 text-sm font-medium text-center" onClick={() => setOpen(false)}>
              Start creating
            </Link>
          </div>
        )}
      </header>
      <main>{children}</main>
      <footer className="border-t border-[#1E1E1E] mt-24">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 grid grid-cols-2 md:grid-cols-5 gap-10 text-sm">
          <div className="col-span-2">
            <div className="font-editorial text-xl">{BRAND.short} AI</div>
            <p className="text-[#71717A] mt-3 max-w-xs leading-relaxed">
              One story. One source of truth. Every stage of production connected.
            </p>
          </div>
          <div>
            <div className="uppercase text-xs tracking-widest text-[#71717A] mb-4">Product</div>
            <ul className="space-y-2 text-[#A1A1AA]">
              <li><Link to="/features">Features</Link></li>
              <li><Link to="/pricing">Pricing</Link></li>
              <li><Link to="/ai-writer">AI Writer</Link></li>
              <li><Link to="/storyboard">Storyboards</Link></li>
            </ul>
          </div>
          <div>
            <div className="uppercase text-xs tracking-widest text-[#71717A] mb-4">Company</div>
            <ul className="space-y-2 text-[#A1A1AA]">
              <li><Link to="/about">About</Link></li>
              <li><Link to="/blog">Blog</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
          <div>
            <div className="uppercase text-xs tracking-widest text-[#71717A] mb-4">Legal</div>
            <ul className="space-y-2 text-[#A1A1AA]">
              <li><Link to="/terms">Terms</Link></li>
              <li><Link to="/privacy">Privacy</Link></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-[#1E1E1E] py-6 text-center text-xs text-[#71717A]">
          © {new Date().getFullYear()} {BRAND.name}. Made for filmmakers.
        </div>
      </footer>
    </div>
  );
}
